import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {},
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: false,
  gameAttempts: 0,
};
